import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgGraduationCapIcon = ({
  title,
  theme = null,
  titleId = "",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="graduation_cap_svg__nc-icon-wrapper">
      <path d="m62.423 17.094-30-14a1.001 1.001 0 0 0-.846 0l-30 14a.999.999 0 0 0 0 1.812l30 14a.992.992 0 0 0 .846 0L43 27.97v25.71l-4.814 6.739A1 1 0 0 0 39 62h10a.999.999 0 0 0 .814-1.581L45 53.68V27.037l17.423-8.131a.999.999 0 0 0 0-1.812z" />
      <path
        data-color="color-2"
        d="m41 31.111-7.731 3.608c-.394.183-.833.281-1.269.281s-.875-.098-1.27-.281L11 25.511V42c0 5.607 9.224 10 21 10 3.244 0 6.283-.343 9-.944V31.111zM47 28.311v20.748c3.726-1.796 6-4.277 6-7.059V25.51l-6 2.801z"
      />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgGraduationCapStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgGraduationCapIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const GraduationCapIcon: any = SvgGraduationCapStyle;
export default GraduationCapIcon;
